(function(){
    document.body.addEventListener('click', function(e) {
        if(e.target && e.target.closest('.btn-wishlist')) {
            e.preventDefault();

            var button = e.target.closest('.btn-wishlist');
            var id = button.getAttribute('data-id') || e.target.closest('[data-id]').getAttribute('data-id');
            var listContent = e.target.closest('.product-list-content');

            button.classList.toggle('active');

            if (button.getAttribute('data-toggle') === 'wishlist-remove') {
                e.target.closest('[data-id]').remove();

                if (listContent && !listContent.querySelectorAll('.product-list-item').length) {
                    listContent.classList.add('empty');
                }
            }

            request = new XMLHttpRequest();
            request.open("GET", '?wishlist='+id, true);
            request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

            request.onload = function () {
                if (request.status >= 200 && request.status < 400) {
                    document.querySelectorAll('.badge-wishlist-count').forEach(function(badge){
                        badge.innerText = request.responseText;
                    })
                }
            };

            request.send();
        }
    });
})();